document.addEventListener("DOMContentLoaded", function () {
	const accordion = document.querySelectorAll(".faq__accordion");

	accordion.forEach((item) => {
		item.addEventListener("click", function (event) {
			event.preventDefault();
			item.classList.toggle("active");
		});
	});
});